import { render, staticRenderFns } from "./ModalPackingSettings.vue?vue&type=template&id=0d1fa850&scoped=true&"
import script from "./ModalPackingSettings.vue?vue&type=script&lang=js&"
export * from "./ModalPackingSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalPackingSettings.vue?vue&type=style&index=0&id=0d1fa850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fa850",
  null
  
)

export default component.exports